import React, { useEffect, useState, lazy, Suspense } from 'react';
import { Container } from 'react-bootstrap';
import styles from './ClinicMaterialsContracts.module.scss';
import DashboardTableCard from '../components/DashboardTableCard';
import { Breadcrumb, Row, Col } from 'react-bootstrap';
import Loader from '../components/Loader';
import { alertModal } from '../utils/modalController';
import { Link } from 'react-router-dom';
import { fetchAuth } from '../utils/fetchAuth';

const EditContractModal = lazy(() => import('../components/EditContractModal'));
const apiUrl = process.env.REACT_APP_API_URL || '';

const ClinicMaterialsContracts: React.FC = () => {

    const [contratos, setContracts] = useState<Contract[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedContract, setSelectedContract] = useState<Contract | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAuth(apiUrl + '/consultorio/contracts') // ajuste aqui seu endpoint real
            .then(async (res) => {
                if (!res.ok) {
                    const data = await res.json();
                    return Promise.reject(data.message || 'Erro ao carregar contratos');
                }
                return res.json();
            })
            .then((json) => {
                setContracts(json);
            })
            .catch((err) => {
                console.error('Erro ao buscar contratos:', err);
                alertModal('Erro ao buscar contratos: ' + err);
                setContracts([]); // fallback
            })
            .finally(() => {
                setLoading(false);
            });
    }, [showModal]);

    if (loading) return <Loader />;

    return (
        <>
            <Container className="center">
                <h2 className={styles["title"]}>Consultório</h2>
                <Row className={styles["row-breadcrumb"]}>
                    <Col>
                        <Breadcrumb className={styles.breadcrumb}>
                            <Breadcrumb.Item linkAs={Link} linkProps={{to:"/consultorio"}}>Consultório</Breadcrumb.Item>
                            <Breadcrumb.Item active>Contratos</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                </Row>
                <DashboardTableCard
                    welcomeMessage={`Contratos`}
                    tableData={{
                        headings: ['Titulo'],
                        data: [
                            [<a href='#' onClick={(e) => {
                                e.preventDefault();
                                setSelectedContract(null);
                                setShowModal(true);
                            }} className={styles["link"]}>Novo contrato</a>],
                            ...contratos.map((contrato) => [
                                <a href='#' onClick={
                                    (e) => {
                                        e.preventDefault();
                                        setSelectedContract(contrato);
                                        setShowModal(true);
                                    }
                                } className={styles["link"]}>
                                    {contrato.title}
                                </a>
                            ])
                        ]

                    }}
                />
            </Container>
            <Suspense fallback={<Loader />}>
                <EditContractModal
                    showModal={showModal}
                    contract={selectedContract || undefined}
                    onHide={() => setShowModal(false)}
                />
            </Suspense>
        </>
    );
};

export default ClinicMaterialsContracts;
